export { NumberTransform as default } from '@ember-data/serializer/transform';
